import Repository from "./Repository";

const resource = "/content";

export default {
	get (type, id){
		return Repository.get(`${resource}/${type}/${id}`);
	},

	// get menu items

	getMenu (){
		return Repository.get(`/api/site/menu`)
	},

	// get node
	getNode (nid){
		return Repository.get(`/node/${nid}?_format=json`)
	},

	// get node
	getNodeWithAlias (alias){
		return Repository.get(`/api/site/content/${alias}`)
	},

	// get group
	getGroup(type){
		return Repository.get(`/api/group/${type}`)
	},

	// get people
	getPeople(){
		return Repository.get(`/api/people`)
	},

	// get news flash
	getNewsFlash(){
		return Repository.get(`/api/getnewsflash?_format=json`)
	},

	// get people
	getCapabilities(){
		return Repository.get(`/api/expertise/capabilities`)
	}


};


